import Vue from "vue";
import ApiService from "@/common/api.service";
import { API_PATH } from "@/common/config";

const PATH = "stock/delivery-notes";

export const GET_STOCK_DELIVERY_NOTES = "getStockDeliveryNotes";
export const GET_STOCK_DELIVERY_NOTE = "getStockDeliveryNote";
export const GET_STOCK_DELIVERY_NOTE_PLANNING = "getStockDeliveryNotePlanning";
export const CREATE_STOCK_DELIVERY_NOTES = "createStockDeliveryNotes";
export const UPDATE_STOCK_DELIVERY_NOTE = "updateStockDeliveryNote";
export const CONFIRM_STOCK_DELIVERY_NOTE = "confirmStockDeliveryNote";
export const CANCEL_STOCK_DELIVERY_NOTE = "cancelStockDeliveryNote";
export const EXECUTE_STOCK_DELIVERY_NOTE = "executeStockDeliveryNote";
export const GET_STOCK_DELIVERY_NOTE_EXECUTION_DRAFT = "getStockDeliveryNoteExecutionDraft";
export const EXPRESS_STOCK_RECEIPT = "expressStockReceipt";
export const EXPRESS_STOCK_DELIVERY = "expressStockDelivery";
export const BULK_STOCK_DELIVERY_NOTE_DATES = "bulkStockDeliveryNoteDates";
export const BULK_STOCK_SCHEDULE_DATES = "bulkStockScheduleDates";
export const SPLIT_STOCK_ORDER_SCHEDULE = "splitStockOrderSchedule";
export const REGENERATE_STOCK_DELIVERY_NOTE_DOCUMENT = "regenerateStockDeliveryNoteDocument";
export const UPLOAD_STOCK_DELIVERY_NOTE_FILES = "uploadStockDeliveryNoteFiles";
export const DELETE_STOCK_DELIVERY_NOTE_FILE = "deleteStockDeliveryNoteFile";
export const DOWNLOAD_STOCK_DELIVERY_NOTE_FILE = "downloadStockDeliveryNoteFile";
export const CREATE_TRANSPORT_ORDER_FROM_DELIVERY_NOTES = "createTransportOrderFromDeliveryNotes";
export const ATTACH_DELIVERY_NOTES_TO_TRANSPORT_ORDER = "attachDeliveryNotesToTransportOrder";
export const DETACH_DELIVERY_NOTES_FROM_TRANSPORT_ORDER = "detachDeliveryNotesFromTransportOrder";
export const CREATE_STOCK_INVOICE_FROM_DELIVERY_NOTES = "createStockInvoiceFromDeliveryNotes";
export const ADD_STOCK_INVOICE_DELIVERY_NOTES = "addStockInvoiceDeliveryNotes";
export const REMOVE_STOCK_INVOICE_DELIVERY_NOTES = "removeStockInvoiceDeliveryNotes";
export const GET_DIRECT_SALE_OPTIONS = "getDirectSaleOptions";
export const CREATE_DIRECT_SALE = "createDirectSale";

const actions = {
  [GET_STOCK_DELIVERY_NOTES](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, {
        ...(params || {}),
        ...context.rootGetters.stockContextFilterParams,
      })
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_DELIVERY_NOTE](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_DELIVERY_NOTE_PLANNING](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/planning`, {
        ...(params || {}),
        ...context.rootGetters.stockContextFilterParams,
      })
        .then(({ data }) => resolve(data.data || []))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_STOCK_DELIVERY_NOTES](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [UPDATE_STOCK_DELIVERY_NOTE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, payload.id, payload.params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CONFIRM_STOCK_DELIVERY_NOTE](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/confirm`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CANCEL_STOCK_DELIVERY_NOTE](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/cancel`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [EXECUTE_STOCK_DELIVERY_NOTE](context, payload) {
    const id = payload.id || payload;
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/execute`, payload.params || {})
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_DELIVERY_NOTE_EXECUTION_DRAFT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, `${id}/execution-draft`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [EXPRESS_STOCK_RECEIPT](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/express-receipt`, params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [EXPRESS_STOCK_DELIVERY](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/express-delivery`, params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [BULK_STOCK_DELIVERY_NOTE_DATES](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/bulk-dates`, params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [BULK_STOCK_SCHEDULE_DATES](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post("stock/order-schedules/bulk-dates", params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [SPLIT_STOCK_ORDER_SCHEDULE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(
        `stock/order-schedules/${payload.orderType}/${payload.scheduleId}/split`,
        payload.params || {}
      )
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [REGENERATE_STOCK_DELIVERY_NOTE_DOCUMENT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/regenerate-document`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [UPLOAD_STOCK_DELIVERY_NOTE_FILES](context, payload) {
    const formData = new FormData();
    (payload.files || []).forEach((file) => formData.append("files[]", file));

    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/files`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DELETE_STOCK_DELIVERY_NOTE_FILE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${PATH}/${payload.id}/files/${payload.fileId}`)
        .then(() => resolve(true))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DOWNLOAD_STOCK_DELIVERY_NOTE_FILE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.downloadFile(
        `${PATH}/${payload.id}/files/${payload.fileId}/download`,
        payload.originalName || payload.name || "download"
      )
        .then(() => resolve(true))
        .catch((error) => reject(error?.response?.data || error));
    });
  },

  [CREATE_TRANSPORT_ORDER_FROM_DELIVERY_NOTES](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post("stock/transport-orders/from-delivery-notes", params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [ATTACH_DELIVERY_NOTES_TO_TRANSPORT_ORDER](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`stock/transport-orders/${payload.id}/delivery-notes`, {
        delivery_note_ids: payload.deliveryNoteIds,
      })
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DETACH_DELIVERY_NOTES_FROM_TRANSPORT_ORDER](context, payload) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .delete(`${API_PATH}stock/transport-orders/${payload.id}/delivery-notes`, {
          data: { delivery_note_ids: payload.deliveryNoteIds },
        })
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_STOCK_INVOICE_FROM_DELIVERY_NOTES](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post("stock/invoices/create-from-delivery-notes", params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [ADD_STOCK_INVOICE_DELIVERY_NOTES](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`stock/invoices/${payload.id}/add-delivery-notes`, {
        delivery_note_ids: payload.deliveryNoteIds,
      })
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_DIRECT_SALE_OPTIONS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query("stock/direct-sales/options", params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_DIRECT_SALE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("stock/direct-sales", payload)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [REMOVE_STOCK_INVOICE_DELIVERY_NOTES](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(`stock/invoices/${payload.id}/remove-delivery-notes`, {
        delivery_note_ids: payload.deliveryNoteIds,
      })
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },
};

export default {
  state: {},
  getters: {},
  actions,
  mutations: {},
};
